import React, {useContext} from 'react';
import '../../polyfill/urlsearchparams.es5';
import {useDispatch} from 'react-redux';
import {Icon} from '@bonprix/design-system';
import {openFilter} from '../FilterSlice.jsx';
import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import {Constants} from '../view-constants';
import {useTrinity} from '../hooks/use-trinity.js';
import Landmark from '@core/scripts/components/landmark-adapter';

export default function FilterOrderingButton({filterViewValue}) {
    const {texts, shopId} = useContext(articleOverviewStaticContext);
    const {sendFilterView, sendClickBasic} = useTrinity();

    const dispatch = useDispatch();

    const open = () => {
        dispatch(openFilter());
        sendClickBasic('open_filter_sorting', Constants.FILTER_VIEW_EVENT_VERSION);

        if (filterViewValue) {
            sendFilterView('filter_layer', filterViewValue, Constants.FILTER_VIEW_EVENT_VERSION);
            const landmarkData = {
                filter_view: filterViewValue,
                filter_view_shopId: shopId.current,
            };
            Landmark.sendActionLandmark(landmarkData);
        }
    };

    return (
        <button className="flex items-center gap-2 py-[9px] l:py-0 cursor-pointer text-clr-primary hover:text-clr-on-bg-low" onClick={open}>
            <Icon variant="control-panel" className="w-6 h-6 fill-current" />
            <span className="typography-bonprix-h5 uppercase font-[SourceSans3]">
                {texts.filter_title}
            </span>
        </button>
    );
}
